import React from "react";
import {
  COLORBLIND_TYPES,
  getColorblindFeColorMatrixValues,
  getColorblindFilterId,
  getColorblindMatrix,
} from "../utils/colorAdjustment";

/**
 * Hidden SVG filter definitions for colorblind image simulation.
 * Mount once near the app root so `filter: url(#...)` works everywhere.
 */
const ColorblindImageFilterDefs: React.FC = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="0"
    height="0"
    style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
  >
    <defs>
      {COLORBLIND_TYPES.map((type) => {
        const matrix = getColorblindMatrix(type);
        const filterId = getColorblindFilterId(type);
        if (!matrix || !filterId) {
          return null;
        }

        return (
          <filter key={filterId} id={filterId} colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values={getColorblindFeColorMatrixValues(matrix)}
            />
          </filter>
        );
      })}
    </defs>
  </svg>
);

export default ColorblindImageFilterDefs;
